import React from 'react';

import { Modal } from '@mui/material';

import { ModalWrapper, ModalHeader, ModalFooter, IconButton, Label, MaterialIconStyle } from './styles';
import { colors } from '@/globalStyles';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CancelIcon from '@mui/icons-material/Close';
import ApplyIcon from '@mui/icons-material/Check';

// TODO: refactoring - in title accept translate key

const ModalComponent = (props) => {
  const {
    open,
    setOpen,
    handleClose,
    handleApply,
    children,
    title,
    height,
    backIcon,
    footer,
    excludeMobileStyle
  } = props;

  const handleDefaultCloseClick = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose || handleDefaultCloseClick}>
      <ModalWrapper height={height} includeFooter={!!footer} excludeMobileStyle={excludeMobileStyle}>
        <ModalHeader>
          <IconButton onClick={handleClose || handleDefaultCloseClick}>
              {backIcon ? <ArrowBackIcon style={MaterialIconStyle}/> : <CancelIcon style={MaterialIconStyle}/>}
          </IconButton>

          <Label>{title}</Label>

          {handleApply && (
            <IconButton onClick={handleApply}>
              <ApplyIcon style={{...MaterialIconStyle, color: colors.primary }} />
            </IconButton>
          )}
        </ModalHeader>
        {children}
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalWrapper>
    </Modal>
  );
};

export default ModalComponent;
